import { EnvNames } from './environment-names.enum';

export const outlookAddinCoreApiServerUrls: Record<EnvNames, string> = {
  [EnvNames.local]: 'https://localhost:53589',
  [EnvNames.dev]: 'https://apicore-dev.pinnakl.com',
  [EnvNames.staging]: 'https://apicore-prod-002.pinnakl.com',
  [EnvNames.prod]: 'https://apicore-prod-002.pinnakl.com',
};

// The legacy /auth (username+password) endpoint moved out of ApiCore into the standalone
// Pnkl.Web.IdentityServer app - everything else the add-in calls stays on outlookAddinCoreApiServerUrls.
export const outlookAddinAuthUrls: Record<EnvNames, string> = {
  [EnvNames.local]: 'https://localhost:5150',
  [EnvNames.dev]: 'https://identity.dev.pinnakl.com',
  [EnvNames.staging]: 'https://identity.pinnakl.com',
  [EnvNames.prod]: 'https://identity.pinnakl.com',
};
